export default __webpack_public_path__ + "static/media/100.3f90dc20.woff";